import { useFormik } from "formik";

import ManageAccountPageWrapper from "../../Layout/ManageAccountPageWrapper";
import PageSection from "../../Layout/PageSection";
import Button from "../../Input/Button";
import FormField from "../../Input/FormField";
import Dropdown from "../../Input/Dropdown";
import { API_URL, STATE_LIST } from "../../../data/constants";

import { useState } from "react";
import axios from "axios";

export default function ManageAccountAddAccountPage({ shouldScroll = false }) {
  const [stateId, setStateId] = useState(1);
  const [existError, setExistError] = useState();
  const [existMessage, setExistMessage] = useState();
  const [addError, setAddError] = useState();
  const [addMessage, setAddMessage] = useState();
  let userRole = localStorage.getItem("userRole");

  function existingValidate(values) {
    const errors = {};
    if (!values.federalTaxId) {
      errors.federalTaxId = "Required";
    } else if (!/^\d+$/.test(values.federalTaxId)) {
      errors.federalTaxId = "Invalid Federal Tax ID (Only Numerical values)";
    } else if (values.federalTaxId.length !== 4) {
      errors.federalTaxId =
        "Please enter only the last 4 of your Federal Tax ID";
    }

    if (!values.customerNumber) {
      errors.customerNumber = "Required";
    } /*else if (!/^\d+$/.test(values.customerNumber)) {
      errors.customerNumber = "Invalid Customer Number (Only Numerical values)";
    }*/

    return errors;
  }

  function addNewValidate(values) {
    const errors = {};
    if (!values.businessName) errors.businessName = "Required";
    if (!values.address1) errors.addressLine1 = "Required";
    if (!values.city) errors.city = "Required";
    if (!values.zip) errors.zipCode = "Required";
    if (!values.contactName) errors.contactName = "Required";
    if (!values.phoneNumber) errors.phoneNumber = "Required";
    return errors;
  }

  const existingForm = useFormik({
    initialValues: {
      federalTaxId: "",
      customerNumber: "",
    },
    validate: existingValidate,
    onSubmit: (values) => {
      setExistError();
      setExistMessage();
      axios
        .post(
          API_URL + "/Accounts/LinkAccount",
          {
            userName: localStorage.getItem("username"),
            customerNumber: values.customerNumber,
            federalTaxId: values.federalTaxId,
          },
          { headers: { Authorization: localStorage.getItem("accessToken") } }
        )
        .then((res) => {
          if (res.data.success === false) setExistError(res.data.message);
          else setExistMessage(res.data.message);
        })
        .catch((err) => console.error(err));
    },
  });

  const addNewForm = useFormik({
    initialValues: {
      businessName: "",
      address1: "",
      address2: "",
      city: "",
      stateId: 0,
      zip: "",
      countryId: 0,
      aglcNumber: "",
      contactName: "",
      phoneNumber: "",
      cellNumber: "",
    },
    validate: addNewValidate,
    onSubmit: (values) => {
      setAddMessage();
      setAddError();
      axios
        .post(
          API_URL + "/Accounts/NewAccount",
          {
            customerName: values.businessName,
            addressLine1: values.address1,
            addressLine2: values.address2,
            city: values.city,
            stateId: stateId,
            zipCode: values.zip,
            aglcNumber: values.aglcNumber,
            contactName: values.contactName,
            phoneNumber: values.phoneNumber,
            cellNumber: values.cellNumber,
          },
          {
            headers: {
              Authorization: localStorage.getItem("accessToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.success === false) setAddError(res.data.message);
          else setAddMessage(res.data.message);
        });
    },
  });

  return (
    <ManageAccountPageWrapper
      shouldScroll={shouldScroll || false}
      pageName= { userRole === "IT-User" ? "Link Account" : "Add Account Or Link Account"}
      subText= { userRole === "IT-User" ? "": "Please fill out one of these forms and we will review and contact you in less than 24 business hours."}>
      <div className="add-account-wrapper">
        <div className="row">
          <div className="col-12 col-md-6">
            <PageSection sectionName="Link Existing Account" isForm={true}>
              <p>
                Submit form to link existing account to online portal.
              </p>
              <form onSubmit={existingForm.handleSubmit}>
                <div className="mb-4">
                  <FormField
                    form={existingForm}
                    field="customerNumber"
                    name="Customer Number"
                    type="text"
                  />
                  <FormField
                    form={existingForm}
                    field="federalTaxId"
                    name="Last four of Federal Tax ID"
                    type="text"
                  />
                </div>
                {existError && <p className="text-danger">{existError}</p>}
                {existMessage && <p>{existMessage}</p>}
                <Button
                  type="submit"
                  text="Link Account"
                  className="btn btn--green btn--bordered"
                  disabled={!(existingForm.dirty && existingForm.isValid)}
                />
              </form>
            </PageSection>
          </div>
          {userRole !== "IT-User" && (
          <div className="col-12 col-md-6">
            <PageSection sectionName="Add New Account" isForm={true}>
              <p>
                Please complete the form to request service for an additional location.
              </p>
              <form onSubmit={addNewForm.handleSubmit}>
                <div className="mb-4">
                  <FormField
                    form={addNewForm}
                    field="businessName"
                    name="Business Name"
                    type="text"
                  />
                  <FormField
                    form={addNewForm}
                    field="address1"
                    name="Address"
                    type="text"
                  />
                  <FormField
                    form={addNewForm}
                    field="address2"
                    name="Address"
                    type="text"
                    helpText="Company, C/O, Apt., Suite, Unit, Building, Floor, etc..."
                    noLabel
                    optional
                  />
                  <div className="form-row">
                    <div className="col-12 col-xl-4">
                      <FormField
                        form={addNewForm}
                        field="city"
                        name="City"
                        type="text"
                      />
                    </div>
                    <div className="col-12 col-xl-4">
                      <Dropdown
                        text="State"
                        data={STATE_LIST}
                        setValue={setStateId}
                      />
                    </div>
                    <div className="col-12 col-xl-4">
                      <FormField
                        form={addNewForm}
                        field="zip"
                        name="Zip Code"
                        type="text"
                      />
                    </div>
                  </div>
                  <FormField
                    form={addNewForm}
                    field="aglcNum"
                    name="AGLC Number"
                    type="text"
                    optional
                  />
                  <FormField
                    form={addNewForm}
                    field="contactName"
                    name="Contact Name"
                    type="text"
                  />
                  <FormField
                    form={addNewForm}
                    field="phoneNumber"
                    name="Phone Number"
                    type="text"
                  />
                  <FormField
                    form={addNewForm}
                    field="cellNumber"
                    name="Cell Number"
                    type="text"
                  />
                </div>
                {addError && <p>{addError}</p>}
                {addMessage && <p>{addMessage}</p>}
                <Button
                  type="submit"
                  text="Send Request"
                  className="btn btn--green btn--bordered"
                  disabled={!(addNewForm.dirty && addNewForm.isValid)}
                />
              </form>
            </PageSection>
          </div>
          )}
        </div>
      </div>
    </ManageAccountPageWrapper>
  );
}
